import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=5ab39290&scoped=true"
import script from "./EditDialog.vue?vue&type=script&lang=ts"
export * from "./EditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab39290",
  null
  
)

export default component.exports